import { defineStore } from "pinia";
import type { Artwork } from "~~/types/artwork";

export interface ArtworkActionStoreState {
    previewUrls: string[];
    showPreview: boolean;
    previewIndex: number
}

export const useArtworkActionStore = defineStore("ArtworkActionStore", {
    state: (): ArtworkActionStoreState => ({
        previewUrls: [],
        showPreview: false,
        previewIndex: 0
    }),

    actions: {
        openPreview(artwork: Artwork, index: number = 0) {
            if (!artwork) return
            this.previewIndex = index
            const allUrls = [artwork.thumbnail, ...artwork.gallery]
            const uniqueUrls = [...new Set(allUrls)]

            if (!uniqueUrls.length) return

            this.previewUrls = uniqueUrls
            this.showPreview = true
        },
        closePreview() {
            this.showPreview = false;
            this.previewUrls = [];
            this.previewIndex = 0
        },
    },
});
